import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { data_ids } from '@/constant/data_ids';
import { ml } from '@/utils/translate_lngs';
import { calcUpperAndLower } from '@/utils/common';

export default (function (param) {
  const [quality, setQuality] = useState({});
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCE_PROCESS_ANALYSIS_QUALITY',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/produce/process/analysis/quality`;
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += `?${key}=${param[key]}`;
        } else {
          url += `&${key}=${param[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  //转成list和series数据
  const object2ListSeries = obj => {
    let list = [];
    let categories_ = [];
    let series_ = {};
    let fields = [];
    let columns_ = [];
    let numbers = {};
    Object.keys(obj).forEach(shotCount => {
      let obj_ = { shot_count: shotCount };
      categories_.push(parseInt(shotCount));
      Object.keys(obj[shotCount]).forEach(id => {
        if (id === 'catch_time') {
          obj_.catch_time = obj[shotCount][id];
        } else {
          if (fields.indexOf(data_ids[id]) === -1) {
            fields.push(data_ids[id]);
          }

          if (!numbers[data_ids[id]]) {
            numbers[data_ids[id]] = [];
          }
          numbers[data_ids[id]].push(obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0);

          obj_[data_ids[id]] = obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0;

          if (!series_[data_ids[id]]) {
            series_[data_ids[id]] = { data: [] };
          }
          series_[data_ids[id]].data.push(obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0);
        }
      });
      list.push(obj_);
    });
    fields.forEach(field => {
      columns_.push({
        field: field,
        title: ml(field),
        halign: 'center',
        align: 'right',
        width: 100,
      });
    });

    Object.keys(numbers).forEach(id => {
      if (series_[id]) {
        let calcData = calcUpperAndLower(numbers[id]);
        series_[id] = { ...series_[id], ...calcData };
      }
    });
    return {
      dataList: list.sort((a, b) => {
        return a.shotCount > b.shotCount ? 1 : -1;
      }),
      categories: categories_,
      series: series_,
      columns: columns_,
      width: 100,
    };
  };

  useEffect(() => {
    if (data && JSON.stringify(data) !== '{}') {
      let new_data = object2ListSeries(data);
      setQuality(new_data);
    }
  }, [data]);

  return [quality, isRequestSuccessed];
});
